import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChatAttachment } from "@/components/ChatAttachment";
import { Paperclip, RefreshCw } from "lucide-react";

const ROLE_LABEL = { customer: "العميل", workshop: "الورشة", admin: "الإدارة" };
const SOURCE_LABEL = { request: "صور العطل", chat: "المحادثة", before: "صور الاستلام", after: "بعد الإصلاح" };
const fmt = (s) => new Date(s).toLocaleString("ar-SA-u-nu-latn", { dateStyle: "short", timeStyle: "short" });

export const AttachmentsGallery = ({ requestId }) => {
  const [items, setItems] = useState(null);
  const load = () => api.get(`/requests/${requestId}/attachments`)
    .then((r) => setItems((prev) => (prev && prev.map((x) => x.file_id).join() === r.data.map((x) => x.file_id).join() ? prev : r.data))).catch(() => setItems((p) => p || []));
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId]);

  return (
    <div data-testid={`attachments-gallery-${requestId}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-sm flex items-center gap-2"><Paperclip className="w-4 h-4 text-accent" /> مرفقات الطلب {items ? `(${items.length})` : ""}</div>
        <Button size="icon" variant="ghost" className="h-8 w-8" onClick={load} data-testid={`attachments-refresh-${requestId}`}><RefreshCw className="w-4 h-4" /></Button>
      </div>
      {items && items.length === 0 && <div className="text-xs text-muted-foreground py-4 text-center" data-testid="attachments-empty">لا توجد مرفقات بعد</div>}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {(items || []).map((a) => (
          <div key={a.file_id} className="rounded-xl border border-border p-2 bg-muted/20 space-y-1.5" data-testid={`attachment-item-${a.file_id}`}>
            <ChatAttachment att={a} compact />
            <div className="flex items-center gap-1 flex-wrap">
              <Badge variant="outline" className="text-[10px] px-1.5">{SOURCE_LABEL[a.source] || a.source}</Badge>
              <span className="text-[10px] text-muted-foreground">{ROLE_LABEL[a.uploader_role] || a.uploader_name}</span>
            </div>
            <div className="text-[10px] text-muted-foreground">{fmt(a.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
